module.exports = __webpack_public_path__ + "static/jules-b90e08fbc1b6805f16d74544ada3dd16.jpg";